import * as CL from '@design-system/component-library';
import { dsClass } from '../../../common/constants/dsClasses';
import { cancelMsg, confirmOrderMsg, t } from '../../../common/i18n';
import { formatPhoneNumber } from '../../../common/utils/phoneNumberUtils';
import { ButtonGroupForSubmitAndBack } from '../../ButtonGroupForSubmitAndBack/ButtonGroupForSubmitAndBack';

export interface UnavailableNumbersModalProps {
  isOpen: boolean;
  unavailableNumbers: string[];
  onConfirmWithReplacement: () => void;
  onCancel: () => void;
  isProcessing?: boolean;
}

/**
 * Modal shown when selected phone numbers are no longer available.
 * Gives user option to auto-replace with new numbers or cancel to review.
 */
export const UnavailableNumbersModal = ({
  isOpen,
  unavailableNumbers,
  onConfirmWithReplacement,
  onCancel,
  isProcessing = false,
}: UnavailableNumbersModalProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <CL.Modal autoOpen={true} onModalClose={onCancel}>
      <h3 className={dsClass.MARGIN_BOTTOM_0}>{t.XP04('Phone number is no longer available')}</h3>
      <p>
        {t.IEC8('Unfortunately, the following phone number or numbers are no longer available')}:
        <br />
        <strong>{unavailableNumbers.map(number => formatPhoneNumber(number, true)).join(', ')}</strong>
      </p>
      <p>
        {t.N894(
          'You can still confirm the order, in which case the next available phone number will be assigned to your subscription. If you wish to choose the phone number yourself, please start the order process again.'
        )}
      </p>
      <ButtonGroupForSubmitAndBack
        className={`${dsClass.PADDING_TOP_4} ${dsClass.TEXT_ALIGN_RIGHT}`}
        submitButtonText={t.RZU4(confirmOrderMsg)}
        onSubmit={onConfirmWithReplacement}
        cancelButtonText={t.B2V1(cancelMsg)}
        onCancel={onCancel}
        submitting={isProcessing}
      />
    </CL.Modal>
  );
};
